import React from "react"

import type { DecimalFormatOptions } from "@/utils/decimal"

import { Decimal } from "../decimal"
import type { DecimalProps } from "../decimal"

type EnergyUnitDecimalProps = Omit<
  DecimalProps,
  "currencyCode" | "format" | "unitsSystem"
>

/**
 * A component that properly formats and internationalizes the provided decimal for displaying an energy unit
 *
 * @param props - The component properties
 * @param children - The children
 * @param props.value - The decimal
 * @param props.placeholder - The placeholder to render instead of the decimal
 * @example
 * return (
 *   <EnergyUnitDecimal value={energy} />
 * )
 */
export const EnergyUnitDecimal = ({
  placeholder,
  useAccountingFormatWhenNegative,
  value,
}: EnergyUnitDecimalProps) => {
  const format: DecimalFormatOptions =
    Math.abs(Number(value)) < 1
      ? { maximumFractionDigits: 6, maximumSignificantDigits: 4 }
      : { precision: 2 }

  return (
    <Decimal
      format={format}
      placeholder={placeholder}
      useAccountingFormatWhenNegative={useAccountingFormatWhenNegative}
      value={value}
    />
  )
}
